"use client"
import { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import { useDispatch, useSelector } from 'react-redux'
import { Box } from '@quintoandar-tokko/jopijs'
import { setKeepLoading } from '@/store/slices/components/calendar/CalendarSlice'
import VisitInformation from '../visitInformation/VisitInformation'
import DatePicker from '../datepicker/Datepicker'
import CalendarForm from '../calendarForm/CalendarForm'
import CalendarControls from '../calendarControls/CalendarControl'
import CalendarSkeleton from '../calendarSkeleton/CalendarSkeleton'
import GenericError from '../genericError/GenericError'
import CalendarClosed from '../calendarClosed/CalendarClosed'
import useHandleInitialCalendarData from '../hooks/useHandleInitialCalendarData'
import style from './calendarMainContent.module.scss'

export default function CalendarMainContent (props) {
  const dispatch = useDispatch()
  const calendar = useSelector(state => state.CalendarSlice)
  const pathname = usePathname()
  const {
    handleDataFromSSR,
    fetchInitialData
  } = useHandleInitialCalendarData()

  useEffect(() => {
    if (calendar.schedule.isMounted) {
      fetchInitialData()
    } else {
      handleDataFromSSR(props.data)
    }
  }, [pathname])

  useEffect(() => {
    if (window.innerWidth < 992) {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }, [calendar.step])

  useEffect(() => {
    // eslint-disable-next-line
    return () => dispatch(setKeepLoading())
  }, [])

  if (calendar.schedule.initializing) return <CalendarSkeleton />
  if (calendar.visit.error) return <GenericError />
  if (!calendar.isOpen) return <CalendarClosed />
  
  return (
    <Box className={style.calendarMainContent}>
      <Box className={style.calendarMainContentUpperSection}>
        <VisitInformation />

        {calendar.step === 1 && <DatePicker />}
        {calendar.step === 2 && <CalendarForm />}
      </Box>
      
      <CalendarControls />
    </Box>
  )
}
